import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(() => ({
  bodyTextBigger: {
    fontSize: '1.25rem',
  },
}));

export default styles;
